module.exports = __webpack_public_path__ + "static/img/guanwang1.be23824b.png";